"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Error32PxFilledIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _iconModule = _interopRequireDefault(require("../icon/icon.module.scss"));
var _classnames = _interopRequireDefault(require("classnames"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["title", "box", "iconState", "className"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var propTypes = {
  /** To give the icon additional context if needed */
  title: _propTypes["default"].string,
  /** To display the icon in a fixed sized box */
  box: _propTypes["default"].bool,
  /** To display the icon as white (inverse), disabled (grey) or information (blue) */
  iconState: _propTypes["default"].oneOf(['icon-invert', 'icon-disabled', 'icon-information'])
};
var url = 'https://www.johnlewis.com/static/ui-assets/hashed/icons-jb/error/error-32px-filled.98e8e711.svg';

/**
 * @deprecated This component is deprecated and will be removed in a future release (V23).
 */
var Error32PxFilledIcon = exports.Error32PxFilledIcon = function Error32PxFilledIcon(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? null : _ref$title,
    _ref$box = _ref.box,
    box = _ref$box === void 0 ? false : _ref$box,
    iconState = _ref.iconState,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  if (box) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _iconModule["default"].box,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
        src: url,
        className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
        alt: title ? title : 'Error Icon',
        width: "32",
        height: "32"
      }, props), {}, {
        "aria-hidden": title ? 'false' : 'true',
        "aria-label": title ? title : 'Error Icon'
      }))
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({
    src: url,
    className: (0, _classnames["default"])(className, _defineProperty({}, _iconModule["default"][iconState], !!iconState)),
    alt: title ? title : 'Error Icon',
    width: "32",
    height: "32"
  }, props), {}, {
    "aria-hidden": title ? 'false' : 'true',
    "aria-label": title ? title : 'Error Icon'
  }));
};
Error32PxFilledIcon.displayName = 'Error32PxFilledIcon';
Error32PxFilledIcon.propTypes = propTypes;
var _default = exports["default"] = Error32PxFilledIcon;